  export enum CheckoutsActionTypes {
    POST_CHECKOUT = 'POST_CHECKOUT',
    GET_PAYFORT_FORM = 'GET_PAYFORT_FORM',
  }
  